import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { Stack, Tooltip, Typography } from "@mui/material";

export interface FieldCaptionIcon {
  toolTipTitle: string;
  Icon: React.ReactNode;
}

interface Props {
  fieldCaptionIcons: FieldCaptionIcon[];
}
const compactModeThreshold = 2;

const FieldsCaptionIconSetContainer = ({ fieldCaptionIcons }: Props) => {
  const isCompactMode = fieldCaptionIcons.length > compactModeThreshold;

  if (isCompactMode) {
    return (
      <Tooltip
        title={
          <Stack useFlexGap spacing={0.5}>
            {fieldCaptionIcons.map(({ Icon, toolTipTitle }) => (
              <Stack useFlexGap key={toolTipTitle} direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
                {Icon}
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  {toolTipTitle}
                </Typography>
              </Stack>
            ))}
          </Stack>
        }
        arrow
        disableInteractive
      >
        <Stack
          direction="row"
          useFlexGap
          spacing={0.25}
          sx={{
            alignItems: "center",
            px: 0.75,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "5px",
            bgcolor: "background.grey",
          }}
        >
          <TuneRoundedIcon color="primary" />
          <Typography variant="caption" sx={{ color: "action.active" }}>
            {fieldCaptionIcons.length}
          </Typography>
        </Stack>
      </Tooltip>
    );
  }
  return (
    <>
      {fieldCaptionIcons.map(({ Icon, toolTipTitle }) => (
        <Tooltip title={toolTipTitle} arrow key={toolTipTitle}>
          <span style={{ display: "contents" }}>{Icon}</span>
        </Tooltip>
      ))}
    </>
  );
};

export default FieldsCaptionIconSetContainer;
